/**
 * レイアウト関連の定数定義
 *
 * @remarks
 * アプリケーション全体で使用されるレイアウト値の定数定義
 * 直接ハードコードせず、この定数を使用することで保守性を向上
 */
export const LAYOUT_CONSTANTS = {
  headerHeight: 72,
  headerMinHeight: 56,
  sidebarWidth: 250,
  sidebarCollapsedWidth: 64,
  zIndex: {
    header: 1200,
    overlay: 1299,
    modal: 1300,
  },
} as const

export type LayoutConstants = typeof LAYOUT_CONSTANTS
